import * as z from 'zod';

import { inventoryAndKitQuerySchema, pickTicketsItemQuerySchema } from '../../../pick-ticket-items-schemas';

const pickTicketsItemCreateSchema = pickTicketsItemQuerySchema.extend({
  selected: z.boolean(),
  disabled: z.boolean(),
  sort_order: z.number(),
});

export type PickTicketsItemCreateSchema = z.infer<typeof pickTicketsItemCreateSchema>;

export const pickTicketsItemCreateFormSchema = pickTicketsItemQuerySchema.pick({ pick_ticket_id: true }).extend({
  inventory_and_kit: inventoryAndKitQuerySchema.nullable(),

  items: z.array(
    pickTicketsItemCreateSchema.refine((data) => !!data.inventory, {
      path: ['inventory'],
      error: 'Inventory is required',
    })
  ),
});

export type PickTicketsItemCreateFormSchema = z.infer<typeof pickTicketsItemCreateFormSchema>;
